export default __webpack_public_path__ + "static/low-3eb0a2996dd9346a6b380476fb6a4a08.png";